import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { ArrowLeft, CalendarDays, MapPin } from "lucide-react";
import { SecondaryNav } from "@/components/booking-home/BookingHomeCards";

export function BiPageHeader({ meta, tab, centreName, multi, centers, center, setCenter, date, setDate, onBack, onOpen, actions }) {
  return (
    <div className="bi-header" style={{ "--bi-accent": meta.accent }} data-testid="bi-topbar">
      <div className="flex flex-col gap-4 xl:flex-row xl:items-center xl:justify-between">
        <div className="flex flex-wrap items-center gap-3">
          <Button variant="outline" className="h-12 border-2 border-[#e2b85a] bg-white text-base text-[#7a0f1d]" onClick={onBack} data-testid="bi-back-home">
            <ArrowLeft className="mr-2 h-5 w-5" />All bookings
          </Button>
          {meta.icon && <img src={`/bi-icons/${meta.icon}.png`} alt="" className="h-12 w-auto drop-shadow" />}
          <div>
            <h1 className="font-serif text-2xl md:text-[28px] font-bold leading-tight" style={{ color: meta.accent }} data-testid="bi-current-title">{meta.title}</h1>
            <p className="flex flex-wrap items-center gap-3 text-base text-[#5a3a22]">
              <span className="flex items-center gap-1" data-testid="bi-centre-name"><MapPin className="h-4 w-4" />{centreName}</span>
              <span className="flex items-center gap-1"><CalendarDays className="h-4 w-4" />{date}</span>
            </p>
          </div>
        </div>
        <div className="flex flex-wrap items-center gap-2">
          {multi && (
            <select className="h-12 rounded-full border-2 border-[#e2b85a] bg-white px-4 text-base" value={center} onChange={(e) => setCenter(e.target.value)} data-testid="bi-centre-select">
              <option value="">All centres</option>
              {centers.map((c) => <option key={c.code} value={c.code}>{c.name || c.code}</option>)}
            </select>)}
          <Input type="date" className="h-12 w-44 rounded-full border-2 border-[#e2b85a] bg-white text-base" value={date} onChange={(e) => setDate(e.target.value)} data-testid="bi-date" />
          {actions}
        </div>
      </div>
      <div className="mt-3"><SecondaryNav active={tab} onOpen={onOpen} /></div>
    </div>
  );
}
